/* global */
// import dayjs from "dayjs";
// import 'dayjs/locale/nb'; // load on demand
import { checkNested } from "./general_functions";
import { show404 } from "./_404";
// import $ from "jquery";
import language from "./translation";


export const getCalendar = (client, obj = { number: 4, id: false }, callback) => {

    let id = obj.id || "";
    let number = obj.number;
    let category = obj.category || client.calendar.localid; //(obj.category ? obj.category +","+ client.calendar.localid : client.calendar.localid);

    // console.log("tests",category);

    // https://sspkalender.prokom.no/api/kalender?Categories=&SearchText=&DateFrom=&DateTo=&Municipalities=&Kunde=kongsbergregionen&Id=19839&ItemDate=&WeekDays=&List=&Count=&Distributor=

    const gc = $.getJSON("https://sspkalender.prokom.no/api/tidspunkt?Categories=" + category + "&SearchText=&DateFrom=&DateTo=&Municipalities=&Kunde=" + client.calendar.group + "&Id=" + id + "&ItemDate=&WeekDays=&List=&Count=" + number + "&Distributor=").done((cal) => {
        // console.log(cal);
        callback(cal);


    });

    return gc;

};

export const getCalendarItem = (client, obj = { number: 4, id: false }, callback) => {

    let id = obj.id || "";
    let number = obj.number;
    let category = obj.category || client.calendar.localid;

    // console.log("tests",category);

    // 

    const gc = $.getJSON("https://sspkalender.prokom.no/api/kalender?Categories=&SearchText=&DateFrom=&DateTo=&Municipalities=&Kunde=" + client.calendar.group + "&Id=" + obj.id.split("_")[0] + "&ItemDate=&WeekDays=&List=&Count=&Distributor=").done((cal) => {
        callback(cal);
    });

    return gc;

};
export const calenderFrontpage = (client, number) => {

    let orig_number = number;
    let checkNumber = parseInt(number) + 1;

    getCalendar(client, { number: checkNumber }, function(cal) {

        $("#events").html(setCalendarList(client, number, cal));

    });

};
export const cleanCalendardObject = (cal, number) => {
    let activities = [],
        c_act = 0;
    if (cal.MonthWithEvents) {
        if (checkNested(cal, "MonthWithEvents", "0", "DaysWithEvents", "0", "Events")) {

            $.each(cal.MonthWithEvents, function(month_nr, month_obj) {
                $.each(month_obj.DaysWithEvents, function(day_nr, day_obj) {
                    $.each(day_obj.Events, function(evenr_nr, event_obj) {

                        // if(){
                        //     console.log("true",event_obj.KalenderObjekt.KategoriIder );
                        // }
                        // else {
                        //     console.log("false",event_obj.KalenderObjekt.KategoriIder)
                        // }

                        c_act++;
                        if (c_act <= number && event_obj.KalenderObjekt.KategoriIder.indexOf(client.calendar.localid) > -1)
                            activities.push(event_obj);

                    });
                });
            });

        }

    }
    return { items: activities, length: c_act }
}
export const setCalendarList = (client, number, cal) => {


    dayjs.locale('nb'); // use Spanish locale globally

    let activities,
        elements = [],
        r = ``,
        c_act = 0,
        newlink = "http://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F1121";

    let filtered = cleanCalendardObject(cal, number);
    activities = filtered.items;
    c_act = filtered.length;

    // console.log("client", client);

    const showLinks = (other = true) => {

        const extracalendars = client.calendar.links;

        let other_cal_links = [];
        let r = ``;


        if (extracalendars) {
            extracalendars.forEach((cal) => {

                other_cal_links.push(`<a href="${cal.url}" class="calendar__others__link" target=_blank><span class="budlight-outgoing-link calendar__others__icon"></span> ${cal.title}</a>`)

            });



            other_cal_links = other_cal_links.join("");


            r += `
                
                    <div class="calendar__others">
                        <div class="row">
                            
                            ${other == true ? `
                            <div class="col-2">
                                <span class="calendar__others__label">${language("ACTIVITY_OTHER")}</span>
                            </div>` : ``}
                            <div class="col">
                                ${other_cal_links}
                            </div>
                        </div>
                    </div>
                    
                `;




        }


        let calendar_possible_new = true;

        if (checkNested(client, "calendar", "possible_new")) {
            calendar_possible_new = client.calendar.possible_new;
        }

        // if (calendar)

        if (c_act > number) {
            r += `
                        <div class="calendar__summary text-right"><a href="/event" class="calendar__seeall">${language("ACTIVITY_SEE_ALL")}</a> 
                        
                    `;

            if (calendar_possible_new === true) {
                r += `
                    <a href="${newlink}" class="calendar__addnew">${language("ACTIVITY_ADD_NEW")}</a></div>`;
            }
        }
        else if (calendar_possible_new === true) {

            r += `
                        <div class="calendar__summary"><a href="${newlink}" class="calendar__addnew">${language("ACTIVITY_ADD_NEW")}</a></div>
                    `;

        }

        return r;

    }

    if (activities.length > 0) {
        $.each(activities, function(a, b) {

            let day = dayjs(b.FraDato).format('DD');
            let month = dayjs(b.FraDato).format("MMM");
            let time = dayjs(b.FraDato).format("HH:mm");

            let adder = ``;
            if (b.Lokasjon.Adresse) {
                adder = `
                    <span class="float-left">
                        <span class="material-icons-outlined calendar__item__icon calendar__item__icon-place"></span>${b.Lokasjon.Adresse}
                    </span>`;
            }
            elements.push(`

                <div class="calendar__item">
                    <div class="row">
                        <div class="">
                            <span class="calendar__item__date">${day}</span>
                            <span class="calendar__item__month">${month}</span>
                        </div>
                        <div class="col">
                            <a href="/event/${b.Id}" class="calendar__item__link">${b.Name}</a>
                            <div class="clearfix">
                                ${adder}
                                <span class="float-right">
                                    <span class="material-icons-outlined calendar__item__icon calendar__item__icon-time"></span>${time}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                `);

        });

        r = elements.join("");


        r += showLinks();

        return r;

    }
    else {


        if (client.calendar.links) {

            return showLinks(false);

        }
        else {

            return `
            <div class="frontpage__eventsitem">
                <div class="row">
                    <div class="col-12">
                        ${language("ACTIVITY_NO_POSTS", newlink)}
                    </div>
                </div>
            </div>
            `;

        }
    }



};
export const showCalendarItem = () => {

    const id = getPageUrl().contentid;
    let ret = ``;

    if (id === "all") {

        getCalendarCategory(false);
        return;
    }

    dayjs.locale('nb'); // use Spanish locale globally
    //     var weekday = require('dayjs/plugin/weekday')
    // dayjs.extend(weekday)

    // console.log("check this id ", id, (id));

    const cleanUrl = (link) => {
        if (!link.match(/^http/))
            link = "https://" + link;


        return link;
    }

    if (id !== "") {

        getCalendarItem(client, { id: id }, function(cal) {



            let activity = cal;

            // if (cal.MonthWithEvents) {
            //     if (checkNested(cal, "MonthWithEvents", "0", "DaysWithEvents", "0", "Events")) {
            //         activity = cal.MonthWithEvents[0].DaysWithEvents[0].Events[0];
            //     }
            // }

            if (activity) {

                // console.log("activity", activity);

                $("#currentPageBreadcrumb").html(activity.Name);

                let intro = ``;

                let cal = activity.KalenderObjekt;
                let address = cal.Sted[0];
                let time = cal.Tidspunkter[0];
                let media;
                let allMedia = cal.MedieFiler;
                let contact = cal.Kontakter;

                let from = dayjs(time.FraDato);
                let to = dayjs(time.TilDato);

                let fulltime = from.format("DD.MMM.YYYY") + " til "; // from.format("dddd").charAt(0).toUpperCase() + from.format("dddd").slice(1) + " mellom " +
                fulltime += to.format("DD.MMM.YYYY. Kl. ");
                fulltime += from.format("HH:mm") + " - " + to.format("HH:mm");

                if (cal.Intro) {
                    intro = `<p class="calendar__event__intro">${cal.Intro}</p>`;
                }

                let images = [];
                if (allMedia.length > 1) {
                    allMedia.forEach(item => {
                        images.push(`<button data-src="https://res.cloudinary.com/ssp/image/fetch/g_center,w_316,h_316,c_fill/${item.LargeUrl}" alt="${item.Description}" class="calendar__event__thumblink"><img src="https://res.cloudinary.com/ssp/image/fetch/g_center,w_88,h_88,c_fill/${item.LargeUrl}" alt="${item.Description}"></button>`)
                    });
                }
                // image += images.join("");


                let image = false;
                if (allMedia[0]) {
                    media = allMedia[0];
                    image = `<div class="main-image" id="mainImage"><img src="https://res.cloudinary.com/ssp/image/fetch/g_center,w_316,h_316,c_fill/${media.LargeUrl}" alt="${media.Description}" class="calendar__event__image"></div><div class="text-left">${images.join("")}</div>`
                }

                // console.log(allMedia);




                const getCategegories = (obj, categories) => {
                    $.each(obj, (nr, cat) => {
                        // console.log("cat", nr, cat.Navn);
                        if (!cat.Navn.match(/hovedkategori|visning/gmi) && cat.Id !== client.calendar.localid) {
                            categories.push(`<a href="#category:${cat.Id}" class="calendar__event__linkpill" data-categoryid="${cat.Id}">${cat.Navn}</a>`); //{name:cat.Navn, id : cat.Id}
                            //     console.log("lok",cat);
                        }
                        if (cat.UnderKategori) {
                            getCategegories(cat.UnderKategori, categories);
                        }

                    });
                }

                let categories = [];

                getCategegories(cal.Kategorier, categories);

                categories = categories.join("");

                let contactinfo = ``;
                let doContact = false;

                const setContact = (contact) => {

                    let contactName = "";
                    if (contact.Navn) {
                        contactName = `
                            <p class="calendar__more__mb">${contact.Navn}</p>`;
                    }

                    let contactEmail = "";
                    if (contact.Epost) {
                        contactEmail = `
                            <p class="calendar__more__mb"><span class="budlight-email mr-3"></span> <a href="mailto:${contact.Epost}" class="calendar__link">${contact.Epost}</a></p>`;
                    }
                    let contactPhone = "";
                    if (contact.Telefon) {
                        contactPhone = `
                            <p class="calendar__more__mb mb-5"><span class="budlight-call mr-3"></span> <a href="tel:${contact.Telefon}" class="calendar__link">${contact.Telefon}</a></p>`
                    }

                    return `
                            ${contactName}
                            ${contactEmail}
                            ${contactPhone}`;

                }

                if (contact.length > 0 || cal.Eier) {

                    let allContact = [];
                    contact.forEach(person => {

                        allContact.push(setContact(person));

                    });

                    let allContactHtml = allContact.join("");

                    doContact = true;

                    let contactTitle = "";
                    if (contact.length > 0) {
                        contactTitle = `
                            <h2 class="calendar__event__h2">${language("ACTIVITY_CONTACT")}</h2>`;
                    }

                    let eier = "";
                    if (cal.Eier) {
                        eier = `<h2 class="calendar__event__h2">${language("ACTIVITY_ORG")}</h2>
                            <p class="calendar__more__mb">${cal.Eier}</p>`;
                    }

                    contactinfo = `
                        <div class="calendar__more">
                            ${eier}
                            
                            ${contactTitle}
                            ${allContactHtml}
                        </div>`;

                }




                let addr = ``;

                // console.log(address);

                if (address.Name) {
                    addr = `
                        <div class="col-1"><span class="budlight-location-pin"></span></div>
                        <div class="col">
                            ${address.Name}<br/>
                            ${address.Adresse}, ${address.PostNr} ${address.PostSted} 
                            <a href="https://www.google.com/maps/search/${address.Adresse}, ${address.PostNr} ${address.PostSted}" class="calendar__item__maplink calendar__link">${language("ACTIVITY_SHOW_IN_MAP")}</a>
                        </div>
                        `;
                }

                let facility = "";
                if (cal.Fasilitetsgruppe) {
                    if (cal.Fasilitetsgruppe[0]) {

                        let facility_list = []
                        cal.Fasilitetsgruppe[0].Fasiliteter.forEach(item => {

                            facility_list.push(`<p>${item.Navn}: ${item.Beskrivelse}</p>`);

                        })

                        facility_list = facility_list.join("");

                        facility = `
                        
                            
                            <h2 class="calendar__event__h2">${cal.Fasilitetsgruppe[0].Navn}</h2>
                            <div class="calendar__event__categories">${facility_list}</div>
                        
                        `

                    }
                }


                let price = "";

                if (cal.Prisliste) {
                    if (cal.Prisliste[0]) {

                        let prices = [];

                        cal.Prisliste.forEach(item => {

                            prices.push(`${item.Beskrivelse}: ${item.PrisFra} - ${item.PrisTil} ${item.PrisGruppe ? `(${item.PrisGruppe})` : ""}`)
                            /*
                            Beskrivelse: "Barn - voksen"
                              Gratis: false       
                              PrisFra: "200"
                              PrisGruppe: null
                              PrisTil: "400"
                              Tittel: null
                          
                            */

                        })

                        let prices_joined = prices.join("</br>");

                        price = `<div>${prices.length > 1 ? "Priser:</br>" : "Pris:" } ${prices_joined}</div>`;

                    }
                }


                // console.log("categories",categories);

                ret = `
            
                <div class="calendar__event ${doContact ? "" : "calendar__event-mb"}">
                    <div class="row">
                        <div class="col-sm-4 order-0 order-sm-2 offset-sm-2 text-center">
                            ${(image ? image : "")}
                        </div>
                        <div class="col-sm-6">
                            <h1 class="calendar__event__title">${cal.Name}</h1>
                            ${intro}

                            <div class="calendar__event__tap">
                                <div class="row mb-4">
                                        ${addr}
                                </div>
                                <div class="row mb-2">
                                    <div class="col-1"><span class="budlight-wall-clock"></div>
                                    <div class="col">${fulltime}</div>
                                </div>
                            </div>
                            
                            
                            <h2 class="calendar__event__h2">${language("ACTIVITY_DESCRIPTION")}</h2>
                            <div class="calendar__event__desc">
                            
                                ${cal.Beskrivelse}
                                
                                ${cal.LinkUtsalg ? `<p class="mt-5">Billetter: <a href='${cleanUrl(cal.LinkUtsalg)}' class="calendar__link">${cal.LinkUtsalg}</a></p>` : ""}
                                ${cal.Nettside ? `<p>Nettside: <a href='${cleanUrl(cal.Nettside)}' class="calendar__link">${cal.Nettside}</a></p>` : ""}
                                
                                ${price}
                            
                            </div>
                            
                            ${facility}
                            
                            ${categories !== "" ? `
                                <h2 class="calendar__event__h2">${language("ACTIVITY_CATEGORY")}</h2>
                                <div class="calendar__event__categories">
                                ${categories}
                                </div>
                            ` : ""}
                            
                            
                        </div>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-sm-6 offset-sm-6">
                        ${contactinfo}
                    </div>
                </div>
                
            
            `


            }
            else {

                ret = show404();

            }

            $(".calendar__event__container").html(ret);


            $(".calendar__event__linkpill").click(function() {
                window.scroll(0, 0)

                getCalendarCategory($(this).data("categoryid"));
            });

            $(".calendar__event__thumblink").click(function() {

                const newUrl = $(this).data("src");

                $("#mainImage").html(`<img src="${newUrl}" />`);

            })

        });
    }
    else {
        getCalendar(client, { category: "" }, function(cal) {
            $(".calendar__event__container").html(setCalendarList(client, 100, cal));
        });
    }

}
export const getCalendarCategory = (id) => {

    getCalendar(client, { category: id }, function(cal) {

        let categorynameObject;

        let allAct = cleanCalendardObject(cal, 1000).items[0];
        // console.log("cal",allAct);

        let name = ""
        if (checkNested(allAct, "KalenderObjekt", "Kategorier", "0", "UnderKategori")) {

            categorynameObject = allAct.KalenderObjekt.Kategorier[0].UnderKategori.filter(item => {
                if (item.Id === id)
                    name = item.Navn;
            })

        }

        // console.log(categorynameObject);


        $(".calendar__event__container").html(`
        
            <h1>${language("ACTIVITY_CATEGORY")}: ${name}</h1>
        
        ` + setCalendarList(client, 1000, cal));
    });

}
